// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_025a50318d--checkbox--V8SSh","label":"_025a50318d--label--spcLW","box":"_025a50318d--box--SMS_5","hasLabel":"_025a50318d--hasLabel--TalIs"};